// extracted by mini-css-extract-plugin
export default {"shareContainer":"Share_shareContainer__JUnVf","shareLinkWrapper":"Share_shareLinkWrapper__tEesk"};